/* @ngInject */
export default function LectureVideoModelService(
  $q,
  $timeout,
  LectureVideoResources,
  QuizModel,
  _,
) {
  const NOT_STARTED = 'not_started';
  const IN_PROGRESS = 'in_progress';
  const COMPLETED = 'completed';

  const LectureVideoModel = function (attributes, catalogId, videoList, index) {
    const _this = this;

    const baseAttributes = {
      startPlaybackFrom: 0,
      cuePoints: [],
    };

    const functions = {
      getStatus,
      isCompleted,
      eventCallback,
      timeCallback,
      getQuiz,
      getReviewOffsetTime,
      registerSeekToFunction,
      seekTo,
      registerPlayFunction,
      play,
      videoLengthInMinutes,
      getQuestionsCount,
      hasValidVideoUrl,
      showDownloadLink,
      showDownloadDropdown,
    };

    _.extend(_this, baseAttributes, attributes, {
      catalogId,
      videoList,
      index,
    }, functions);

    function getStatus() {
      return _this.progress;
    }

    function eventCallback(event, second, totalLength) {
      /* eslint-disable camelcase */
      if (event !== 'unload' || second !== 0) {
        // we are currently using a get so the parameter is not converted
        _this.lastEventCallbackPromise = LectureVideoResources.watchEvent({
          catalogId: _this.catalogId,
          videoListId: _this.videoList.id,
          id: _this.id,
          second,
          video_action: event,
          total: totalLength,
        }).$promise.then((response) => {
          const lectureVideo = response.result;

          if (lectureVideo.pointsReceived) {
            _this.newPointsReceived = lectureVideo.pointsReceived;
            _this.pointsReceived = lectureVideo.pointsReceived;
            _this.newLeaderboardPoints = lectureVideo.leaderboardPoints;
            _this.newLeaderboardRank = lectureVideo.leaderboardRank;
            _this.newPriorLeaderboardRank = lectureVideo.priorLeaderboardRank;
          }

          _this.progress = lectureVideo.progress;

          if (_this.videoList) {
            _this.videoList.updatePointsReceived();
            _this.videoList.updateStatus();
          }

          return _this;
        });

        // the timecallback happens before the event callback sometimes
        $timeout(() => {
          _this.startPlaybackFrom = second;
        });

        return _this.lastEventCallbackPromise;
      }

      return null;
    }

    function timeCallback(second, ignoreQuiz) {
      _this.startPlaybackFrom = second;

      if (!ignoreQuiz && _this.quiz) {
        const question = _this.quiz.getNextQuestionToDisplay();
        if (question?.second <= second) {
          return question;
        }
      }

      return null;
    }

    function isCompleted() {
      return _this.progress === COMPLETED;
    }

    function getQuiz(quizCatalogId) {
      if (_this.questionSetId) {
        return QuizModel.get(quizCatalogId, _this.questionSetId, { videoListId: _this.videoList.id, lectureVideoId: _this.id })
          .then((quiz) => {
            _this.quiz = quiz;

            if (quiz.submission) {
              quiz.setResponses(quiz.submission.responses);
            }

            if (_this.video.length && _this.video.length > 0) {
              _.each(quiz.questions, (question) => {
                _this.cuePoints.push((question.second / _this.video.length) * 100);
              });
            }

            return quiz;
          });
      }
      return $q.reject();
    }

    function getReviewOffsetTime() {
      return _this.quiz.currentQuestion.second < 10 ? 0 : _this.quiz.currentQuestion.second - 10;
    }

    function registerSeekToFunction(funct) {
      _this.seekToFunction = funct;
    }

    function seekTo(second) {
      if (_this.seekToFunction) {
        _this.seekToFunction(second);
      }
    }

    function registerPlayFunction(funct) {
      _this.playFunction = funct;
    }

    function play(playIndex) {
      if (_this.playFunction) {
        _this.playFunction(playIndex);
      }
    }

    function videoLengthInMinutes() {
      if (_this.video?.length) {
        return Math.floor(_this.video.length / 60);
      }
      return 0;
    }

    function getQuestionsCount() {
      return _this.questionsCount;
    }

    function hasValidVideoUrl() {
      return _this.video.lowQualityUrl || _this.video.mediumQualityUrl || (_this.video.mediaSource === '.mp4' && _this.video.originalUrl);
    }

    function showDownloadLink() {
      return _this.video?.canDownload && (_this.video.downloadLink || _this.video.highQualityUrl);
    }

    function showDownloadDropdown() {
      return _this.video && (_this.showDownloadLink() || _this.video.transcriptUrl || _this.video.textTranscriptUrl || _this.video.slidesUrl);
    }
  };

  LectureVideoModel.BACKEND_EVENT_NAMES = {
    START: 'start',
    PLAY: 'play',
    PAUSE: 'pause',
    COMPLETE: 'ended',
    UNLOAD: 'unload',
  };

  return LectureVideoModel;
}
